import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {NotFoundPage} from '@components/common';
import {TvOwnerGuard} from '@guards/tv-owner.guard';
import {AdvertiserGuard} from '@guards/advertiser.guard';
import {MarketplaceGuard} from '@guards/marketplace.guard';

export const routes: Routes = [
  {path: '', pathMatch: 'full', redirectTo: '/authentication'},
  {path: 'app', canActivate: [TvOwnerGuard], loadChildren: () => import('./modules/dw-app/dw-app.module').then(m => m.DwAppModule)},
  {path: 'authentication',
    loadChildren: () => import('./modules/authentication/authentication.module').then(m => m.AuthenticationModule)},
  {path: 'advertiser', canActivate: [AdvertiserGuard],
    loadChildren: () => import('./modules/advertiser/advertiser.module').then(m => m.AdvertiserModule)},
  {path: 'marketplace', canActivate: [MarketplaceGuard], loadChildren: () => import('./modules/marketplace/marketplace.module')
      .then(m => m.MarketplaceModule)},
  {path: '**', component: NotFoundPage},
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {scrollPositionRestoration: 'top'})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
